var map = {
	"./Avatars": 25351,
	"./Avatars.stories": 16334,
	"./Avatars.stories.tsx": 16334,
	"./Avatars.tsx": 25351,
	"./NFT": 78886,
	"./NFT.tsx": 78886,
	"./TheAngel.png": 18817,
	"./TheFounder.png": 68675,
	"./TheHodler.png": 31954,
	"./TheInvestor.png": 66640,
	"./TheTrader.png": 66140,
	"./mystery.png": 9362,
	"./mystery1.png": 54321,
	"./videos/ape.mp4": 87537,
	"./videos/eagle.mp4": 67845,
	"./videos/rhino.mp4": 48511,
	"./videos/shark.mp4": 62918,
	"./videos/tiger.mp4": 41988,
	"assets/avatars/Avatars.stories": 16334,
	"assets/avatars/Avatars.stories.tsx": 16334,
	"assets/avatars/Avatars.tsx": 25351,
	"assets/avatars/NFT.tsx": 78886,
	"assets/avatars/TheAngel.png": 18817,
	"assets/avatars/TheFounder.png": 68675,
	"assets/avatars/TheHodler.png": 31954,
	"assets/avatars/TheInvestor.png": 66640,
	"assets/avatars/TheTrader.png": 66140,
	"assets/avatars/mystery.png": 9362,
	"assets/avatars/mystery1.png": 54321,
	"assets/avatars/videos/ape.mp4": 87537,
	"assets/avatars/videos/eagle.mp4": 67845,
	"assets/avatars/videos/rhino.mp4": 48511,
	"assets/avatars/videos/shark.mp4": 62918,
	"assets/avatars/videos/tiger.mp4": 41988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99866;